import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @file Created on Mon Aug 06 2018
 * @author BPo
 */


import api from '../../api';
import { CONSTANTS } from '../../../constants';
import { FormDefinitionConverter, jsonConversions } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
/**
 * Form restriction transport layer.
 */

export var FormLayer =
/*#__PURE__*/
function () {
  function FormLayer() {
    _classCallCheck(this, FormLayer);
  }

  _createClass(FormLayer, [{
    key: "loadDefinition",

    /**
     * Load profile for the current logged in user.
     * @param path Path to the specific form endpoint
     */
    value: function loadDefinition(path, params) {
      var _this = this;

      var findPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(path)).get({
        responseType: 'json',
        params: params
      }).then(function (response) {
        return _this.converter.toObject(response.data, jsonConversions);
      });
      return findPromise;
    }
  }]);

  return FormLayer;
}();

__decorate([Inject, __metadata("design:type", FormDefinitionConverter)], FormLayer.prototype, "converter", void 0);